import React, { type ReactNode } from 'react';
import { styled } from '@compiled/react';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

export type FieldGroupProps = {
	children: ReactNode;
	error: string | undefined;
};

export default function FieldGroup(props: FieldGroupProps) {
	return (
		<div>
			{props.children}
			<ErrorMessage>{props.error}</ErrorMessage>
		</div>
	);
}

FieldGroup.defaultProps = {
	error: undefined,
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ErrorMessage = styled.div({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	color: token('color.text.danger', colors.R300),
	paddingTop: token('space.050', '4px'),
	paddingRight: 0,
	paddingBottom: token('space.050', '4px'),
	paddingLeft: 0,
});
